module.exports = __webpack_public_path__ + "static/img/104901.712d4333.png";